import { React, useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

import urls, { getCsrfToken } from './urls.js';

import '../com.zedock.common.style/Section.css';
import '../com.zedock.common.style/common.css';

function Section() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [showDiv, setShowDiv] = useState("");
  const [recentProducts, setRecentProducts] = useState([]);
  const [mostLovedProducts, setMostLovedProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  useEffect(() => {
    getViewedProducts();
    handleMostLovedProducts();
  }, [location.pathname]);

  const getViewedProducts = async () => {
    try {
      setLoading(true);
      const response = await
        fetch(`${urls.BASE_URL}` + "/zedock-web/viewedProducts", {

          headers: {
            "X-XSRF-TOKEN": getCsrfToken()
          },
          method: "GET",
          credentials: "include"   // ✅ send JSESSIONID cookie
        });
      const data = await response.json();
      setRecentProducts(data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleMostLovedProducts = async (e) => {
    try {
      setLoading(true);
      const response = await
        fetch(`${urls.BASE_URL}` + "/zedock-web/viewedProducts/mostLovedProducts", {

          headers: {
            "X-XSRF-TOKEN": getCsrfToken()
          },
          method: "GET",
          credentials: "include"   // ✅ send JSESSIONID cookie
        });
      const data = await response.json();
      setMostLovedProducts(data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleMarketLeads = async (e) => {
    e.preventDefault();
    try {
      const response = await

        fetch(`${urls.BASE_URL}` + "/zedock-web/marketLeads", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": getCsrfToken()

          },
          body: email
        });

      setShowDiv(true);
      setTimeout(() => {
        setShowDiv(false);
      }, 2000);
    } catch (error) {
      console.error("Error:", error);
    } finally {
    }
  };

  return (
    <div className="container px-0    ">
      <div className="zd-wrap p-2 p-lg-4">

        {/* ---------- recently viewed products ---------- */}

        {recentProducts.length > 0 && (
          <div className="row  g-2 mb-2">
            <div className="col-12">
              <div className="zd-recently-wrap">

                <div>

                  <div className="zd-viewed-head">
                    <h3>Recently Viewed</h3>
                    <span>Pick up where you left off</span>
                  </div>


                  <div className="scroll-div">

                    {recentProducts.map((viewedProduct) => (

                      <div className="zd-viewed-card">
                        <img className="zd-viewed-img"
                          src={`${urls.CDN_URL + 'products/' + viewedProduct.sku}.webp`}
                          onClick={() => navigate("/Specifications", { state: viewedProduct })}
                          loading="lazy"
                        />


                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}


        {/* ---------- MostLoved reviews  ---------- */}
        <div className="row  g-2 mb-2">
          <div className="col-12">

            <div className="zd-mostLoved-wrap">
              {mostLovedProducts.length > 0 && (

                <div>

                  <div className="zd-viewed-head">
                    <h3>Customers’ Most-Loved</h3>
                    <span>Deals on new launch items</span>
                  </div>


                  <div className="scroll-div">

                    {mostLovedProducts.map((mostLovedProduct) => (

                      <div className="zd-viewed-card">
                        <img className="zd-viewed-img"
                          src={`${urls.CDN_URL + 'products/' + mostLovedProduct.sku}.webp`}
                          onClick={() => navigate("/Specifications", { state: mostLovedProduct })}
                          loading="lazy"
                        />


                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* ---------- recent reviews  ---------- */}
        <div className="row  g-2 mb-2">
          <div className="col-12">

            <div className="zd-reviews-wrap">
              <div className="zd-viewed-head">
                <h3>What our customers say</h3>
              </div>
              <div className="zd-reviews-scroll">

                <div className="zd-review-card">
                  <div className="zd-review-rating">
                    <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                  </div>
                  <p className="zd-review-text">"Quality is exactly as shown, delivery was quick too."</p>
                  <p className="zd-review-name">Priya Sharma</p>
                  <p className="zd-review-loc">Bengaluru, Karnataka</p>
                </div>

                <div className="zd-review-card">
                  <div className="zd-review-rating">
                    <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                  </div>
                  <p className="zd-review-text">"Very happy with the fit and fabric. Will order again."</p>
                  <p className="zd-review-name">Rohit Verma</p>
                  <p className="zd-review-loc">Pune, Maharashtra</p>
                </div>

                <div className="zd-review-card">
                  <div className="zd-review-rating">
                    <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                  </div>
                  <p className="zd-review-text">"Good packaging and the product matched the photos."</p>
                  <p className="zd-review-name">Anjali Nair</p>
                  <p className="zd-review-loc">Kochi, Kerala</p>
                </div>

                <div className="zd-review-card">
                  <div className="zd-review-rating">
                    <span>★</span><span>★</span><span>★</span><span>★</span>
                  </div>
                  <p className="zd-review-text">"Customer support was prompt when I had a query."</p>
                  <p className="zd-review-name">Karan Mehta</p>
                  <p className="zd-review-loc">Ahmedabad, Gujarat</p>
                </div>

                <div className="zd-review-card">
                  <div className="zd-review-rating">
                    <span>★</span><span>★</span><span>★</span><span>★</span>
                  </div>
                  <p className="zd-review-text">"Fast shipping and everything arrived in perfect condition."</p>
                  <p className="zd-review-name">Sneha Iyer</p>
                  <p className="zd-review-loc">Chennai, Tamil Nadu</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      {/* ---------- subscribe  ---------- */}
      <div className="row  g-2 mb-0">
        <div className="col-12">

          <div className="zd-subscribe">
            <span className="zd-subscribe-eyebrow">Join our list</span>
            <h3>Get 10% off your first order</h3>
            <p className="zd-subscribe-sub">Subscribe now and unlock your welcome discount instantly.</p>

            <form className="zd-subscribe-form" onSubmit={handleMarketLeads}>
              <label htmlFor="subscribe-email" className="visually-hidden">Email address</label>
              <input
                id="subscribe-email"
                type="email"
                placeholder="Enter your email"
                className="zd-subscribe-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="zd-subscribe-btn">Subscribe</button>
            </form>

            <p className="zd-subscribe-note">Coupon code sent to your inbox after signup.</p>
            {showDiv && (

              <div className="zd-alert zd-alert-success">You have successfully subscribed</div>

            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section;
